import Vue from 'vue'
import vuexI18n from 'vuex-i18n'
import store from './store/store'

const defaultLanguage = 'bs'

Vue.use(vuexI18n.plugin, store)

Vue.i18n.fallback(defaultLanguage)

const setInitLanguage = () => {
    if (localStorage.language && localStorage.language !== '') {
        Vue.i18n.set(localStorage.language)
    } else {
        Vue.i18n.set(defaultLanguage)
        localStorage.setItem('language', defaultLanguage)
    }
}

setInitLanguage()